import { render, staticRenderFns } from "./OrgTeam.vue?vue&type=template&id=cc0d8f22&"
import script from "./OrgTeam.vue?vue&type=script&lang=js&"
export * from "./OrgTeam.vue?vue&type=script&lang=js&"
import style0 from "./OrgTeam.vue?vue&type=style&index=0&id=cc0d8f22&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports